import CharacterUtils from '../utils/CharacterUtils';

export interface QueryResponseData {
    data: CharacterListContract;
}
export interface CharacterListContract {
    characters: Array<ShortCharacterContract>;
    characterSlotLimit: number | null;
    canUnlockCharacters: boolean;
}

// TODO this is also the same short character as the RE genereted.. that one is outedate.. can we share?
export interface ShortCharacterContract {
    avatarUrl: string;
    backdropUrl: string;
    campaignId: number | null;
    campaignName: string | null;
    characterSecondaryInfo: string;
    classDescription: string;
    coverImageUrl: string;
    createdDate: number;
    id: number;
    isAssigned: boolean;
    isReady: boolean;
    lastModifiedDate: number;
    level: number;
    name: string;
    raceName: string;
    status: CharacterStatusEnum;
    statusSlug: string;
}
export enum CharacterStatusEnum {
    Active = 1,
    Deleted = 2,
    Locked = 3,
}

export interface CharacterData extends ShortCharacterContract {
    userName: string | null;
}
export interface AppData {
    characters: Array<CharacterData>;
    maxCharacterSlotsAllowed: number | null;
    hasLockedCharacters: boolean;
}

//SORTING TYPES
export enum SortTypeEnum {
    Created = 'created',
    Name = 'name',
    Level = 'level',
    Modified = 'modified',
}

export enum SortOrderEnum {
    Ascending = 'asc',
    Descending = 'desc',
}

export const SortByPropMap = {
    [SortTypeEnum.Created]: CharacterUtils.getCreatedDate,
    [SortTypeEnum.Level]: CharacterUtils.getLevel,
    [SortTypeEnum.Modified]: CharacterUtils.getLastModifiedDate,
    [SortTypeEnum.Name]: CharacterUtils.getName,
};
